export const unsupportedBrowsers = {
  ie: '>0',
  safari: '<13',
};

export const ipadUnsupportedBrowsers = {
  ie: '>0',
  safari: '<12',
};
